module.exports = __webpack_public_path__ + "img/man_testimonial.822eafc1.png";